import React from 'react';
import { motion } from 'framer-motion';
import { Box, Flex } from '@chakra-ui/react';

const svgVariants = {
  hidden: {
    opacity: 0,
  },
  visible: {
    opacity: 1,
    transition: { duration: 0.5 },
  },
};

const pathVariants = {
  hidden: {
    scale: 0,
    opacity: 0,
  },
  visible: {
    scale: 1,
    opacity: 1,
    transition: {
      duration: 0.5,
    },
  },
};

export const FaceSvg = ({ y }) => {
  return (
    <Flex
      className="face"
      width={{ base: 48, md: 64 }}
      height="auto"
      justifyContent="center"
      alignItems="center"
    >
      <motion.svg
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 140.000000 140.000000"
        preserveAspectRatio="xMidYMid meet"
        variants={svgVariants}
        initial="hidden"
        animate="visible"
        style={{ y }}
      >
        <g
          transform="translate(0.000000,140.000000) scale(0.050000,-0.050000)"
          stroke="currentColor"
          fill="currentColor"
        >
          <motion.path
            d="M1290 2679 c-55 -7 -169 -9 -253 -3 -248 16 -280 -15 -433 -426 -66
-175 -92 -313 -85 -447 3 -54 -3 -83 -16 -75 -11 7 2 -46 28 -118 26 -71 41
-130 34 -130 -7 0 5 -13 26 -29 51 -37 74 31 48 143 -22 94 -24 246 -4 246 8
0 18 -65 21 -143 9 -217 78 -269 341 -254 240 14 408 204 385 435 -7 64 -154
112 -346 112 l-194 0 54 59 c299 326 715 346 1049 51 127 -112 122 -120 -70
-120 -171 -1 -306 -23 -339 -56 -31 -31 -37 -200 -9 -229 15 -14 23 -36 18
-50 -5 -14 6 -39 23 -56 18 -18 32 -25 32 -17 0 9 29 -12 65 -47 94 -91 425
-147 489 -83 31 31 57 -55 27 -90 -16 -20 -14 -33 6 -49 39 -33 53 -8 54 95 0
51 13 146 29 212 43 176 39 284 -10 310 -44 23 -59 186 -20 210 100 62 -69
369 -210 383 -85 8 -187 43 -277 96 -62 36 -112 52 -145 46 -28 -6 -89 1 -135
13 -48 14 -124 19 -183 11z m-319 -38 c-7 -11 -25 -14 -41 -8 -17 6 -63 -8
-105 -31 l-75 -43 56 50 c54 49 191 75 165 32z m369 -121 c1 27 3 27 20 0 14
-22 19 -23 20 -4 0 42 34 9 44 -43 16 -83 -109 -39 -134 47 -14 49 -13 49 17
10 24 -30 32 -33 33 -10z m-80 -54 c0 -5 -13 -22 -29 -38 -33 -33 -97 34 -78
84 10 25 107 -16 107 -46z m-382 27 c-4 -3 -44 -27 -88 -53 l-80 -47 48 54
c27 29 67 53 89 53 22 0 36 -3 31 -7z m1191 -91 c32 -34 50 -62 39 -62 -11 0
-55 37 -99 82 -43 46 -61 74 -39 62 22 -11 66 -48 99 -82z m-934 -2 c-3 -32
-7 -33 -48 -6 -41 27 -43 26 -33 -13 8 -32 1 -41 -30 -41 -23 0 -46 -8 -52
-17 -6 -10 -36 -23 -67 -29 -30 -6 -73 -17 -95 -24 -39 -13 -39 -13 -1 18 21
18 64 32 95 32 63 0 72 30 25 81 -30 33 -24 35 88 35 103 0 120 -5 118 -36z
m-235 -461 c0 -13 158 -38 301 -48 131 -8 153 -69 79 -220 -84 -173 -421 -259
-542 -138 -63 63 35 342 122 348 19 1 14 10 -15 23 -49 24 -149 -37 -105 -64
27 -17 6 -73 -32 -88 -44 -17 -35 74 13 135 36 45 37 51 7 40 -21 -9 -30 -6
-22 6 14 23 194 28 194 6z m1295 -69 c37 -43 57 -122 48 -192 -9 -73 -26 -128
-45 -146 -17 -17 -20 4 -10 83 17 136 -16 265 -67 265 -21 0 -43 11 -49 25 -6
14 -6 3 0 -23 l13 -48 -63 44 c-82 59 -79 63 33 53 71 -7 106 -22 140 -61z
m-250 -3 c41 -7 70 -19 65 -27 -11 -19 47 -44 68 -31 9 5 16 -2 18 -15 1 -13
17 -85 36 -160 39 -160 44 -149 -93 -166 -252 -29 -515 182 -447 360 18 46
194 65 353 39z"
            variants={pathVariants}
          />
          <motion.path
            d="M1126 1788 c23 -24 -54 -78 -115 -80 -147 -6 -281 -108 -142 -108 54
0 67 7 58 30 -6 17 -1 30 11 30 12 0 22 -9 22 -20 0 -11 28 -20 61 -20 36 0
56 -8 49 -20 -20 -32 36 -23 91 15 70 48 50 185 -27 185 -11 0 -15 -6 -8 -12z"
            variants={pathVariants}
          />
          <motion.path
            d="M1658 1717 c-20 -98 1 -115 165 -129 70 -6 130 -20 134 -30 10 -29
128 -22 118 7 -10 31 -143 97 -235 115 -38 8 -95 21 -125 30 -30 8 -56 11 -57
7z"
            variants={pathVariants}
          />
          <motion.path
            d="M1742 1389 c-2 -39 -108 -149 -144 -149 -10 0 -18 -10 -18 -21 0 -12
9 -16 20 -9 11 7 15 0 9 -14 -6 -16 18 -43 56 -64 78 -45 171 -128 197 -177
26 -48 15 -44 -54 16 -176 155 -488 189 -705 76 -124 -64 -161 -73 -135 -30
22 35 197 142 215 131 9 -6 17 4 17 21 0 45 -21 39 -160 -39 -150 -85 -216
-94 -173 -25 42 66 59 135 34 135 -11 0 -21 -14 -21 -31 0 -17 -8 -26 -18 -20
-47 29 -94 -205 -52 -261 18 -24 29 -28 29 -11 1 18 27 25 86 23 159 -7 193 0
234 44 73 78 441 68 441 -12 0 -16 28 -35 64 -43 35 -7 93 -31 130 -51 83 -47
76 -47 125 6 28 29 34 48 19 57 -16 10 -16 18 0 28 12 7 28 -1 34 -18 22 -57
48 -32 40 38 -10 79 -26 111 -54 111 -11 0 -15 -9 -9 -19 7 -11 2 -36 -11 -56
-21 -35 -33 -28 -151 82 -87 82 -120 125 -103 135 13 9 30 12 38 7 32 -20 54
44 39 111 -10 39 -18 52 -19 29z"
            variants={pathVariants}
          />
          <motion.path
            d="M1205 1387 c-51 -22 -22 -47 54 -47 62 0 81 -9 91 -42 17 -51 2 -66
-66 -67 -32 -1 -56 -13 -59 -32 -5 -24 13 -31 81 -30 76 1 86 6 78 39 -8 29
-3 36 22 26 22 -8 29 -3 21 17 -8 20 2 29 30 29 22 0 46 9 53 20 7 11 32 16
56 10 62 -15 116 22 74 50 -45 29 -132 24 -160 -10 -31 -38 -58 -38 -100 0
-36 33 -136 54 -175 37z"
            variants={pathVariants}
          />
          <motion.path
            d="M592 1345 c-8 -25 -24 -45 -35 -45 -10 0 -14 -9 -7 -20 7 -12 2 -19
-12 -15 -66 14 -117 -284 -60 -353 12 -14 16 -32 8 -39 -7 -7 3 -13 23 -13 29
0 34 -11 24 -60 -7 -34 -3 -60 8 -60 10 0 19 -13 19 -30 0 -40 80 -275 102
-299 10 -10 18 -107 18 -215 0 -191 23 -257 47 -136 16 80 53 77 53 -5 1 -49
5 -58 20 -35 13 20 19 22 20 5 0 -14 18 -25 40 -25 39 0 39 2 8 50 -18 27 -28
61 -22 76 5 14 -3 43 -18 64 -32 43 -38 182 -8 200 11 7 19 28 19 46 -1 25 -7
22 -20 -11 -20 -51 -59 -61 -59 -14 0 16 -13 35 -30 42 -34 13 -41 78 -10 97
11 7 30 -10 42 -37 14 -30 34 -46 50 -39 47 17 32 51 -71 164 -154 168 -232
479 -142 569 10 10 13 31 7 47 -7 17 -3 36 8 43 11 7 14 31 6 53 -14 39 -15
38 -28 -5z m-49 -302 c-13 -43 -17 -95 -10 -114 9 -23 6 -31 -7 -22 -33 20
-42 151 -12 176 32 27 35 65 3 45 -15 -9 -18 -5 -8 11 34 54 59 -15 34 -96z"
            variants={pathVariants}
          />
          <motion.path
            d="M2240 1220 c0 -23 18 -92 40 -155 49 -138 50 -158 7 -122 -30 25 -32
18 -23 -77 5 -57 2 -115 -7 -130 -12 -19 -17 -15 -18 14 -2 28 -6 31 -14 11
-24 -61 -222 -270 -240 -253 -6 6 22 61 62 121 40 60 78 146 85 191 7 44 21
86 31 92 9 6 17 28 17 49 0 22 7 39 15 39 8 0 12 43 8 95 -7 78 -11 87 -25 50
-9 -25 -25 -45 -35 -45 -9 0 -23 -54 -30 -121 -11 -109 -38 -192 -71 -219 -26
-22 -122 -218 -122 -249 0 -42 -95 -131 -141 -131 -38 0 -63 -43 -42 -72 27
-38 99 -31 113 11 7 23 26 41 43 41 16 0 24 8 19 18 -6 9 10 17 35 17 41 0 47
-9 45 -72 -2 -88 -88 -222 -114 -180 -12 18 -17 19 -18 3 0 -13 10 -30 22 -37
16 -10 15 -19 -3 -30 -49 -30 31 -79 130 -79 91 0 91 0 91 70 0 58 -7 70 -42
70 -24 0 -38 10 -33 25 5 14 21 25 36 25 16 0 32 18 35 40 4 22 33 109 66 194
32 85 58 173 58 196 0 23 23 63 51 90 103 95 154 311 107 447 -33 95 -138 142
-138 63z"
            variants={pathVariants}
          />
          <motion.path
            d="M671 1141 c-8 -12 -22 -17 -31 -11 -10 6 -8 -19 3 -55 11 -36 29
-101 40 -145 20 -84 90 -216 171 -325 26 -36 42 -65 35 -65 -8 0 -3 -13 10
-28 12 -16 25 -59 28 -95 7 -103 48 -166 87 -134 18 15 22 28 9 33 -11 3 -16
20 -10 35 6 16 2 29 -10 29 -12 0 -16 14 -10 31 7 17 -2 46 -18 65 -16 19 -35
57 -42 84 -6 28 -51 110 -99 183 -103 157 -128 219 -133 326 -3 88 -10 104
-30 72z"
            variants={pathVariants}
          />
          <motion.path
            d="M1660 650 c-28 -34 -13 -90 25 -90 32 0 80 75 64 101 -17 28 -61 23
-89 -11z"
            variants={pathVariants}
          />
          <motion.path
            d="M1580 580 c-24 -15 -24 -19 -2 -20 19 0 24 -17 15 -61 -7 -34 -5 -56
5 -50 25 15 40 111 18 111 -10 0 -13 9 -6 20 15 25 8 25 -30 0z"
            variants={pathVariants}
          />
          <motion.path
            d="M353 435 c-18 -66 -16 -95 7 -95 11 0 20 14 20 30 0 17 9 30 20 30
11 0 20 18 20 40 0 55 -52 51 -67 -5z"
            variants={pathVariants}
          />
          <motion.path
            d="M1603 355 c-2 -19 -14 -35 -27 -35 -14 0 -6 -19 18 -42 23 -24 52
-37 64 -29 31 19 27 51 -7 51 -15 0 -32 20 -37 45 -6 30 -9 33 -11 10z"
            variants={pathVariants}
          />
          <motion.path
            d="M1067 291 c7 -19 1 -25 -18 -18 -16 6 -29 1 -29 -11 0 -23 65 -31 85
-10 17 17 -5 68 -29 68 -11 0 -15 -13 -9 -29z"
            variants={pathVariants}
          />
          <motion.path
            d="M1385 278 c-8 -31 -15 -35 -27 -15 -13 21 -17 18 -18 -9 0 -20 -8
-31 -19 -25 -10 6 -24 2 -31 -9 -8 -13 -28 -10 -56 10 -59 41 -87 38 -48 -5
55 -62 10 -100 -57 -48 -65 51 -95 54 -130 11 -23 -26 -22 -31 2 -27 51 7 106
-1 94 -13 -7 -7 5 -31 26 -54 21 -22 45 -35 52 -27 8 7 -3 27 -24 44 -43 34
-35 34 89 -2 39 -11 46 -8 36 19 -7 17 -4 32 7 32 17 0 27 -27 22 -62 -1 -7
32 -13 74 -13 41 0 94 -6 119 -14 28 -8 44 -5 44 9 0 12 -9 17 -20 10 -11 -7
-20 1 -20 17 0 42 -46 52 -72 16 -18 -23 -22 -4 -19 83 4 118 -5 145 -24 72z"
            variants={pathVariants}
          />
          <motion.path
            d="M1451 242 c-6 -9 7 -22 28 -28 22 -5 43 1 48 13 6 13 11 7 11 -12 1
-19 10 -35 21 -35 21 0 49 38 37 50 -18 19 -135 28 -145 12z"
            variants={pathVariants}
          />
          <motion.path
            d="M1698 138 c-16 -9 -53 -18 -84 -18 -50 0 -56 -7 -50 -55 7 -60 107
-92 137 -44 8 13 37 24 65 24 60 0 87 65 37 87 -54 23 -76 25 -105 6z"
            variants={pathVariants}
          />
        </g>
      </motion.svg>
    </Flex>
  );
};
